import RowCollapsiblePanel from './RowCollapsiblePanel.component';
import { listTypes } from '../utils/constants';

export const rowType = listTypes.COLLAPSIBLE_PANEL;
export default RowCollapsiblePanel;
